<app-overlay
  [visible]="opened"
  [container]="container"
  [overlayMask]="false"
  [animate]="!!animate"
  (onContentReady)="onContentReadyInternal()"
>
  <ng-template overlayContent>
    <div
      class="floating-container alignment-horizontal-{{ horizontalAlignment }}"
      #divContent
    >
      <ng-container *ngIf="!contentTpl?.templateRef; else contentTplRef">
        <ng-content></ng-content>
      </ng-container>

      <ng-template #contentTplRef>
        <ng-template [ngTemplateOutlet]="contentTpl.templateRef"></ng-template>
      </ng-template>
    </div>
  </ng-template>
</app-overlay>
